export const FETCH_RAW_STOCKS_REQUEST = 'FETCH_RAW_STOCKS_REQUEST';
export const FETCH_RAW_STOCKS_SUCCESS = 'FETCH_RAW_STOCKS_SUCCESS';
export const FETCH_RAW_STOCKS_FAILURE = 'FETCH_RAW_STOCKS_FAILURE';

export const CREATE_RAW_STOCK = 'CREATE_RAW_STOCK';
export const UPDATE_RAW_STOCK = 'UPDATE_RAW_STOCK';
export const DELETE_RAW_STOCK = 'DELETE_RAW_STOCK';

export const FETCH_RAW_STOCK_REPORT_REQUEST = 'FETCH_RAW_STOCK_REPORT_REQUEST';
export const FETCH_RAW_STOCK_REPORT_SUCCESS = 'FETCH_RAW_STOCK_REPORT_SUCCESS';
export const FETCH_RAW_STOCK_REPORT_FAILURE = 'FETCH_RAW_STOCK_REPORT_FAILURE'; 